<template>
  <product-list
    :productService = productService
    :productComponent = productComponent
  ></product-list>
</template>

<script>
  import ProductList from '@/components/Common/Product/ProductList'
  import productService from '@/services/rental/product'

  export default {
    components: {
      ProductList
    },
    data () {
      return {
        productService: productService,
        productComponent: 'RentalProductSales'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Rental/Products/Overview.vue